import { call, put } from 'redux-saga/effects';

import {
  oneIncDefaultsPaymentFailed,
  oneIncDefaultsPaymentLoaded,
  oneIncSessionCreated,
} from '../actions';
import { API_HEADER_V2, apiCallWithApiKey, get } from '../services/api';
import { doNothing } from '../services/utils';

export function* createOneIncSession(dispatch, { payload }) {
  const { email, origin, token } = payload;
  const requestString = JSON.stringify({ email, origin, token });

  try {
    const response = yield call(
      apiCallWithApiKey,
      'purchase/OneInc/SessionId',
      {
        body: { email, origin, token },
        headers: API_HEADER_V2,
        method: 'POST',
      },
      dispatch,
    );

    if (response.IsValid) {
      const { portalOneSessionKey } = response.Data;
      yield put(oneIncSessionCreated(portalOneSessionKey));
    } else {
      const error = response?.Message
        || 'Error retrieving getOneIncSessionId.';
      let responseString = '';

      try {
        if (response) {
          responseString = JSON.stringify(response);
        }
      } catch (parseError) {
        responseString = `INVALID JSON REQUEST: ${parseError}`;
      }

      yield call(
        apiCallWithApiKey,
        'purchase/Log/QuoteSiteError',
        {
          body: {
            Action: 'Petcloud getOneIncSessionId',
            Email: email,
            Endpoint: 'purchase/OneInc/SessionId',
            ErrorDescription: `Petcloude ${error}`,
            HttpStatusCode: response.status,
            // Not compatible with all browsers
            OperatingSystem: navigator?.userAgentData?.platform,
            Request: requestString,
            Response: responseString,
            UserAgent: navigator.userAgent,
          },
          headers: API_HEADER_V2,
          method: 'POST',
        },
        dispatch,
      );
    }
  } catch (error) {
    yield call(
      apiCallWithApiKey,
      'purchase/Log/QuoteSiteError',
      {
        body: {
          Action: 'Petcloud getOneIncSessionId',
          Email: email,
          Endpoint: 'purchase/OneInc/SessionId',
          ErrorDescription: `Petcloude catch ${error}`,
          // Not compatible with all browsers
          OperatingSystem: navigator?.userAgentData?.platform,
          Request: requestString,
          Response: null,
          UserAgent: navigator.userAgent,
        },
        headers: API_HEADER_V2,
        method: 'POST',
      },
      dispatch,
    );

    doNothing();
  }
}

export function* loadDefaultpayments(dispatch, { payload }) {
  const { email, origin, token } = payload;

  const response = yield call(get, dispatch, '/api/Billing/InfoByCustomer');

  if (response.IsValid) {
    const {
      BillingInfoList: billingInfoList,
      DefaultPaymentProfileIdACH: defaultTokenACH,
      DefaultPaymentProfileIdCC: defaultTokenCC,
    } = response.Data;
    const haveDefault = !!defaultTokenACH || !!defaultTokenCC;
    const isTwoDefaults = !!defaultTokenACH && !!defaultTokenCC;

    if (isTwoDefaults) {
      yield put(oneIncDefaultsPaymentLoaded({
        bankAccountDefault: billingInfoList
          .find((item) => item.PaymentProfileId === defaultTokenACH),
        billingInfoList,
        creditCardDefault: billingInfoList
          .find((item) => item.PaymentProfileId === defaultTokenCC),
        defaultTokenACH,
        defaultTokenCC,
        haveDefault,
        isTwoDefaults,
      }));
    } else {
      const data = { payload: { email, origin, token } };

      yield call(createOneIncSession, dispatch, data);
    }
  } else {
    yield put(oneIncDefaultsPaymentFailed());
  }
}
